import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from 'ustore-ui';

import { PendingOrderPanelItem } from '../../../core/models/pending-order.model';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-pending-order-panel',
  standalone: true,
  imports: [CommonModule, I18nPipe, Button],
  templateUrl: './pending-order-panel.component.html',
  styleUrls: ['./pending-order-panel.component.scss'],
})
export class PendingOrderPanelComponent {
  @Input() orders: PendingOrderPanelItem[] = [];

  @Output() completeData = new EventEmitter<string>();

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  }

  getQuantityLabel(quantity: number): string {
    return quantity > 1
      ? 'components.orderPanel.signaturePlural'
      : 'components.orderPanel.signatureSingular';
  }

  onCompleteDataClick(token: string): void {
    if (token) {
      this.completeData.emit(token);
    }
  }
}
